import(/* webpackMode: "eager" */ "/app/app/(home)/profile/configuration/page.tsx");
